import { CommonFlags as c, DefaultColumns, EntityColumn, EntityColumnFlags, EntityDefinition, MicroMClient, ValuesObject } from "@mcurros2/microm";
import { ClientesProductos } from "../ClientesProductos/ClientesProductos";
import { ClientesServicios } from "../ClientesServicios/ClientesServicios";
import { ACTSeleccionarProductos } from "./ACTSeleccionarProductos";
import { ClientesTiendasProductos } from "./ClientesTiendasProductos";
import { ClientesTiendasProductosOverrides } from "./ClientesTiendasProductosOverrides";

const columns = () =>
(
    {
        c_cliente_id: new EntityColumn<string>({ name: 'c_cliente_id', type: 'char', length: 20, flags: c.PK, prompt: 'Cliente ID' }),
        c_tienda_id: new EntityColumn<string>({ name: 'c_tienda_id', type: 'char', length: 20, flags: c.PK, prompt: 'Tienda ID' }),
        c_producto_id: new EntityColumn<string>({ name: 'c_producto_id', type: 'char', length: 20, flags: c.PK, prompt: 'Producto ID' }),
        n_ultimo_precio: new EntityColumn<number>({ name: 'n_ultimo_precio', type: 'decimal', length: 14, flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Ultimo precio' }),
        i_ultima_cantidad: new EntityColumn<number>({ name: 'i_ultima_cantidad', type: 'int', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Ultima cantidad' }),
        c_servicio_id: new EntityColumn<string[]>({ name: 'c_servicio_id', type: 'varchar', flags: c.Edit | EntityColumnFlags.nullable, prompt: 'Servicios', isArray: true }),
        ...DefaultColumns()
    }
)

const views = () =>
(
    {
        ctip_brwStandard: {
            name: 'ctip_brwStandard', keyMappings: { c_producto_id: 0 },
            gridColumnsOverrides: ClientesTiendasProductosOverrides
        },
        ctip_brwNoEnTienda: { name: 'ctip_brwNoEnTienda', keyMappings: { c_producto_id: 0 } },
        ctip_brwProductosPorTienda: { name: 'ctip_brwProductosPorTienda', keyMappings: { c_cliente_id: 0, c_producto_id: 2 } }
    }
)

const lookups = () =>
(
    {
        'Productos': {
            name: 'Productos',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new ClientesProductos(client, parentKeys)
        },
        'ProductosNoEnTienda': {
            name: 'ProductosNoEnTienda',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            view: 'ctip_brwNoEnTienda',
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new ClientesTiendasProductos(client, parentKeys)
        },
        'Servicios': {
            name: 'Servicios',
            viewMapping: { keyIndex: 0, descriptionIndex: 1 },
            entityConstructor: (client: MicroMClient, parentKeys?: ValuesObject) => new ClientesServicios(client, parentKeys)
        }
    }
)

const clientActions = () =>
(
    {
        ACTSeleccionarProductos: ACTSeleccionarProductos,
    }
)

export class ClientesTiendasProductosDef extends EntityDefinition {

    columns = columns();
    views = views();
    lookups = lookups();
    clientActions = clientActions();

    constructor() {
        super('ClientesTiendasProductos');
    }
}